import { Playground, Props } from 'docz';
import { Breadcrumbs } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Breadcrumbs,
  React
};